import { PostModal } from './PostModal';
export default PostModal;
